import { call, put, takeEvery, delay } from 'redux-saga/effects';
import * as actions from './_actions';
import * as types from './_actionTypes';
import CollegeStudentHelper from '../../../../utils/API/BackendHelper/college/student';




function transformStudentData(students) {
  return students.map(student => {
    const studentData = student.students?.[0] || {};

    return {
      // Top-level user info
      user_id: student.id ?? null,          // user id from API top-level
      username: student.username ?? null,
      firstName: student.first_name ?? null,
      lastName: student.last_name ?? null,
      phone: student.phone ?? null,
      college: student.college_id ?? null,
      createdAt: student.created_at ?? null,
      updatedAt: student.updated_at ?? null,
      status: student.is_active ? 'active' : 'suspended',

      // Academic/student record info
      id: studentData.id ?? null,           // student record id
      name: studentData.candidate_name ?? null,
      rollNumber: studentData.registration_no ?? null, // more meaningful than student_id
      studentTableId: studentData.student_table_id ?? null,
      degree: studentData.degree ?? null,
      gender: studentData.gender ?? null,
      dob: studentData.dob ?? null,

      // Mocked progress (until real one is implemented)
      progress: Math.floor(Math.random() * 100)
    };
  });
}

function* fetchStudentsSaga(action) {
  console.log("jere")
  try {
    const params = action.payload || {};
    const response = yield call(CollegeStudentHelper.getAllStudents, params);

    if (response?.success) {
      const students = response.data || [];
      console.log('fetched students:', students[0]);
      const transformedStudents = transformStudentData(students);

      console.log('Transformed Students:', JSON.stringify(transformedStudents, null, 2));

      yield put(actions.fetchStudentsSuccess({
        students: transformedStudents,
        pagination: response.pagination
      }));
    } else {
      yield put(actions.fetchStudentsFailure(response?.message || 'Failed to fetch students'));
    }
  } catch (error) {
    console.error('Error in fetchStudentsSaga:', error);
    yield put(actions.fetchStudentsFailure(error.message || 'Failed to fetch students'));
  }
}



/**
 * Upload students via Excel file
 */
export const uploadStudentsSaga = function* (action) {
  try {
    const { files, courseIds, collegeId, semester, batch } = action.payload;
    console.log(action.payload);
    if (!files || files.length === 0) {
      yield put(actions.uploadStudentsFailure('No file selected'));
      return;
    }

    const file = files[0];
    
    // ✅ Parse Excel file on frontend
    const XLSX = require('xlsx'); // Install: npm install xlsx
    
    try {
      // Read file as array buffer
      const arrayBuffer = yield new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsArrayBuffer(file);
      });

      // Parse Excel file
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      
      // Convert to JSON
      const studentsData = XLSX.utils.sheet_to_json(worksheet);
      
      console.log('📊 Parsed Excel data:', studentsData.length, 'students');
      console.log('📋 First student:', studentsData[0]);
      
      if (studentsData.length === 0) {
        yield put(actions.uploadStudentsFailure('Excel file is empty'));
        return;
      }

      // ✅ Transform data to match backend expectations
      const transformedStudents = studentsData.map((student, index) => {
        try {
          return {
            // ✅ User creation fields (required by backend)
            username: student.email || `student${index + 1}@temp.com`,
            email: student.email || `student${index + 1}@temp.com`,
            password: student.password || 'TempPass@123', // Backend will generate if not provided
            role: 'student',
            first_name: student.first_name || '', // ✅ Added required field
            last_name: student.last_name || '',   // ✅ Added required field
            phone: student.phone, // ✅ Added required field
            college_id: '', // ✅ Backend will handle this from auth context
            is_active: true,  // ✅ Added required field
            is_credentials_sent: false, // ✅ Added required field
            // ✅ Student profile fields matching database schema
            candidate_name: student.candidate_name || '',
            registration_no: student.registration_no || null,
            nad_number: student.nad_number || null,
            gender: student.gender || null,
            dob: student.dob || null,
            age_years: student.age_years ? parseInt(student.age_years) : null,
            father_name: student.father_name || null,
            mother_name: student.mother_name || null,
            mobile: student.mobile || null,
            alt_phone: student.alt_phone || null,
            aadhaar_number: student.aadhaar_number || null,
            aadhaar_enrollment: student.aadhaar_enrollment || null,
            corresponding_address: student.corresponding_address || null,
            degree: student.degree || null,
            subject: student.subject || null,
            subject_1: student.subject_1 || null,
            subject_2: student.subject_2 || null,
            subject_3: student.subject_3 || null,
            minor: student.minor || null,
            category: student.category || null,
            reservation: student.reservation || null,
            other: student.other || null,
            ews: student.ews === true || student.ews === 'true' || student.ews === 1,
            xth_marks_sheet_serial: student.xth_marks_sheet_serial || null,
            xth_pass_year: student.xth_pass_year ? parseInt(student.xth_pass_year) : null,
            xii_board: student.xii_board || null,
            xii_roll_no: student.xii_roll_no || null,
            admission_date: student.admission_date || new Date().toISOString().split('T')[0],
            admitted_as: student.admitted_as || null,
            admission_type: student.admission_type || null,
            list_number: student.list_number ? parseInt(student.list_number) : null,
            // ✅ Handle array fields from comma-separated strings
            skill: student.skill ? student.skill.toString().split(',').map(s => s.trim()) : [],
            cocurricular: student.cocurricular ? student.cocurricular.toString().split(',').map(s => s.trim()) : [],
          
          
          };
        } catch (transformError) {
          console.error(`Error transforming student at row ${index + 2}:`, transformError);
          throw new Error(`Row ${index + 2}: Invalid data format`);
        }
      });

      console.log('✅ Transformed students data:', transformedStudents.length);
      console.log('📋 Sample transformed student:', JSON.stringify(transformedStudents[0], null, 2));

      // ✅ Send JSON data to backend (not FormData)
      const requestData = {
        users: transformedStudents,
        role: 'student',
        collegeId: collegeId, 
        batch: batch || null,
        semester: semester || null,
        // Admin must provide this
      };

      const response = yield call(CollegeStudentHelper.bulkEnrollStudents, requestData);
      
      if (response && response.success) {
        const result = {
          total: transformedStudents.length,
          successful: response.data.successful?.length || 0,
          failed: response.data.failed?.length || 0,
          successData: response.data.successful || [],
          errors: response.data.failed?.map((failure, index) => 
            `${failure.username}: ${failure.error}`
          ) || []
        };
        
        console.log('✅ Upload result:', result);
        yield put(actions.uploadStudentsSuccess(result));
        
        // Refresh the students list after successful upload
        yield delay(1000);
        yield put(actions.fetchStudentsRequest());
      } else {
        console.error('❌ Backend response failed:', response);
        yield put(actions.uploadStudentsFailure(response?.message || 'Upload failed'));
      }

    } catch (parseError) {
      console.error('❌ Error parsing Excel file:', parseError);
      yield put(actions.uploadStudentsFailure('Invalid Excel file format'));
    }

  } catch (error) {
    console.error('💥 Error in uploadStudentsSaga:', error);
    yield put(actions.uploadStudentsFailure(error.message || 'Upload failed. Please try again.'));
  }
};

/**
 * Update student (admin)
 */
function* updateStudentSaga(action) {
  try {
    const { studentId, updateData } = action.payload;
    
    const response = yield call(CollegeStudentHelper.updateStudent, studentId, updateData);
    
    if (response && response.success) {
      const transformedStudent = transformStudentData([response.data.user])[0];
      yield put(actions.updateStudentSuccess(transformedStudent));
      
      // Refresh students list with collegeId if it was in updateData
      const params = {};
      if (updateData.collegeId) {
        params.collegeId = updateData.collegeId;
      }
      yield put(actions.fetchStudentsRequest(params));
    } else {
      yield put(actions.updateStudentFailure(response?.message || 'Failed to update student'));
    }
  } catch (error) {
    console.error('Error in updateStudentSaga:', error);
    yield put(actions.updateStudentFailure(error.message || 'Failed to update student'));
  }
}


export function* adminStudentSaga() {
  yield takeEvery(types.FETCH_STUDENTS_REQUEST, fetchStudentsSaga);
  yield takeEvery(types.UPLOAD_STUDENTS_REQUEST, uploadStudentsSaga);
  yield takeEvery(types.UPDATE_STUDENT_REQUEST, updateStudentSaga);
}